import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dialog as MUIDailog } from '@material-ui/core';
import withSizes from 'react-sizes';
import { dialogSelectors, merchantSelectors, otpActions, websiteDetailsActionTypes, otpSelectors, dialogActions, websiteDetailsActions } from '@store/ducks';
import Sheet from 'deltoid/core/Blocks/Sheet';
import VerifyOTP from '@components/BaseComponents/VerifyOTP';
import Components from '@components/WebsiteDetails/StatusDialogs';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { SpinLoader } from 'deltoid/core/Loaders';

const Dialog = ({ type,
  open,
  isMobile,
  verifyOTP,
  identity,
  onClose: onCloseProp,
  registeredMobile,
  otpErrMsg,
  dialogOnClose,
  fetchCurrentWebsiteDetails
}) => {
  const [retryTime, setRetryTime] = useState(60 * 1000);
  const [disableResend, setDisableResend] = useState(true);

  const getChild = (type) => {
    let child = '';
    switch (type) {
      case 'website-status': {
        child = <Components.WebsiteStatus />;
        break;
      }
      case 'website-status-active': {
        child = <Components.WebsiteActive handleClose={handleProceedClose} />;
        break;
      }
      case 'website-status-inactive': {
        child = <Components.WebsiteInactive handleClose={handleProceedClose} />;
        break;
      }
      case 'website-ws-loader': {
        child = <SpinLoader overflow='hidden' />;
        break;
      }
      case 'verify-otp-website': {
        child = (
          <VerifyOTP
            heading='Verify OTP'
            title={`Enter OTP sent on ${registeredMobile}`}
            subTitle='We have sent an OTP to your registered mobile number'
            handleVerifyOTP={(code) => verifyOTP(identity, code)}
            goBack={onCloseProp}
            errMsg={otpErrMsg}
            resendOtp={() => {
              setRetryTime(60 * 1000);
              setDisableResend(true);
              resentOtp(identity);
            }}
            retryTime={retryTime}
            onTimerComplete={() => {
              setRetryTime(false);
              setDisableResend(false);
            }}
            disableResend={disableResend}
          />
        );
        break;
      }
      default: {
        child = null;
      }
    }
    return child;
  };

  const handleProceedClose = () => {
    dialogOnClose();
    fetchCurrentWebsiteDetails();
  };
  const handleClose = () => onCloseProp();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <>
      {getChild(type) ?
        !isMobile || type === 'website-ws-loader' ? (
          <MUIDailog
            open={open}
            onClose={type == 'website-ws-loader' ? () => { } : handleClose}
            maxWidth={'md'}
            PaperProps={
              type === 'website-ws-loader'
                ? {
                  style: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                  },
                }
                : {}
            }
          >
            {getChild(type)}
          </MUIDailog>
        ) : (
          <Sheet className='bg-white sheet-b-radius' open={open} bottom
            onOverlayClick={() => { }}
          >
            {type === 'website-status' ? <Components.MobileWebsiteStatus /> :
              type === 'website-status-active' ? <Components.MobileWebsiteActive handleClose={handleProceedClose} /> :
                type === 'website-status-inactive' ? <Components.MobileWebsiteInactive handleClose={handleProceedClose} /> : <></>}
          </Sheet>
        ) : (
          <></>
        )
      }
    </>
  );
};

Dialog.propTypes = {
  open: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  verifyOTP: PropTypes.func.isRequired,
  identity: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  registeredMobile: PropTypes.string.isRequired,
  otpErrMsg: PropTypes.string,
  dialogOnClose: PropTypes.func.isRequired,
  fetchCurrentWebsiteDetails: PropTypes.func.isRequired,
};

Dialog.defaultProps = {
  open: false,
  isMobile: false,
  verifyOTP: () => { },
  identity: '',
  onClose: () => { },
  registeredMobile: '',
  otpErrMsg: '',
  dialogOnClose: () => { },
  fetchCurrentWebsiteDetails: () => { },
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});

const ResponsiveDialog = withSizes(mapSizesToProps)(Dialog);

const mapStateToProps = (state) => {
  return {
    open: dialogSelectors.open(state),
    type: dialogSelectors.type(state),
    identity: merchantSelectors.getMerchantEmail(state),
    registeredMobile: merchantSelectors.getMerchantMobile(state),
    otpErrMsg: otpSelectors.getError(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  verifyOTP: (identity, code) => dispatch(otpActions.verifyOTP(identity, 'SignIn', code, websiteDetailsActionTypes.checkWebsiteLiveliness)),
  dialogOnClose: () => dispatch(dialogActions.close()),
  resentOtp: (email) => dispatch(otpActions.sendOTP(['email', 'sms'], email, 'update_website_details', 'SignIn')),
  fetchCurrentWebsiteDetails: () => dispatch(websiteDetailsActions.fetchCurrentWebsiteDetails()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveDialog);
